import _ from 'lodash'
import { READ_PROFILES_FROM_FORAGE, RESET_PROFILES, SET_PROFILE, REMOVE_PROFILE } from './constants'
import { USERS_LOGIN_USER, USERS_FORGET_USERS, USERS_LOGOUT_USER } from '../constants'

// Initial state for users in the store
const initialState = {}
// const initialState  = {
//     tq: { testuser_1: 'Default' },
//     sisi: {},
// }

const exists = (state, serverId, userId) =>
    state[serverId] != null && state[serverId][userId] != null

const noChange = (state, serverId, userId, profile) =>
    exists(state, serverId, userId) && state[serverId][userId] === profile

const addOrUpdateItem = (state, serverId, userId, profile) => ({
    ...state,
    [serverId]: {
        ...(state[serverId] || {}),
        [userId]: profile,
    },
})

const removeItem = (state, serverId, userId) => ({
    ...state,
    [serverId]: _.omit(state[serverId], userId),
})

const add = (state, serverId, userId, profile) => {
    // User is already in the list
    if (noChange(state, serverId, userId, profile)) {
        return state
    }

    // Update the user in the list
    return addOrUpdateItem(state, serverId, userId, profile)
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Read the users pinned state from forage
        case READ_PROFILES_FROM_FORAGE:
            return action.payload

        // Reset profiles to empty
        case RESET_PROFILES:
        case USERS_FORGET_USERS:
            return {}

        case USERS_LOGIN_USER: {
            // const { serverId, userId, profile } = action.payload
            const { serverId, user: { userId, profile } } = action.payload

            // If no profile is provided
            if (profile == null || profile === '') return state

            // Since we are logging in, prevent logging in with Default
            // from resetting the profile for the user
            if (profile === 'Default') {
                return state
            }

            return add(state, serverId, userId, profile)
        }

        // Add profile to a user
        case SET_PROFILE: {
            // const { serverId, userId, profile } = action.payload
            const { serverId, userId, profile } = action.payload

            // If explicitly setting the profile to 'Default'
            // then we remove it instead
            if (profile === 'Default') {
                if (!exists(state, serverId, userId)) return state
                return removeItem(state, serverId, userId)
            }

            return add(state, serverId, userId, profile)
        }

        case USERS_LOGOUT_USER:
            return state

        case REMOVE_PROFILE: {
            const { serverId, userId } = action.payload
            if (!exists(state, serverId, userId)) return state
            return removeItem(state, serverId, userId)
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/profiles/reducer.js